module.exports = __webpack_public_path__ + "static/media/4_hotspot.50382485.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/4_hotspot.jpg
// module id = 314
// module chunks = 0